module.exports = __webpack_public_path__ + "static/media/hi_shelf.648f5e9d.png";